export default "/images/7525bd1af2f427634f65f08ac0f58572.avif";